'use client';

import { ServiceModules, type ServiceModulesContent } from '../components';

const BRAND_DESIGN_SERVICE_CONTENT: ServiceModulesContent = {
  layout: {
    nextLink: '/airtime',
    hoverTextColor: 'text-at',
    logoColor: 'text-at',
  },
  hero: {
    backgroundColor: 'bg-navy',
    backgroundImage: '/images/services/brand_waves.png',
    headingStatement: 'Building businesses on stable ground',
    headingStatementLines: ['Building', 'businesses\u00A0on', 'stable\u00A0ground'],
    heading: 'Finance',
    headingLargeText:
      'We see it all the time—a lot of founders get overwhelmed by the world of fundraising, or frustrated by complicated financial models that are hard to understand and even harder to maintain.',
    headingSmallText:
      'But getting a handle on your startup’s finances shouldn’t be difficult, and it doesn’t have to be. We can help you make sense of it all so you can focus on building and scaling a great company.',
    imageTopOffset: 576,
  },
  teamProof: {
    text: 'Our team has built over 100 financial models and guided multiple companies from seed to acquisition, both in-house and on a consultant basis.',
  },
  whatWeDo: {
    thinTitle: undefined,
    boldTitle: 'Making finance make sense',
    textParagraphs: [
      'We can help your company realize its potential by creating simple, sturdy frameworks that drive toward stability and scale. With those tools in hand, you can raise money more effectively, optimize how you spend it, and lay a sustainable path toward making more of it, all while earning the freedom to focus on what matters.',
    ],
    ctaText: "Let's clarify the picture",
    ctaLink: 'mailto:hello@all-turtles.com?subject=Finance%20inquiry',
    rightColumnItems: [
      {
        heading: 'Financial models',
        paragraph:
          'Accurate information makes for better decisions. We’ll build a model tailored to your mission and KPIs that adapts and scales as your company evolves. All of our financial models are straightforward, easy to update, and beautifully presented.',
      },
      {
        heading: 'Fundraising support',
        paragraph:
          'Get aligned with present and future investors—we can help with communication, legal documentation, paperwork, due diligence, and deal structuring. You get a smoother fundraising process, and investors can have confidence their money will be used with purpose.',
      },
      {
        heading: 'Stable, sustainable systems',
        paragraph:
          'Set your company up for ongoing success with the right tech stack and financial playbook. We can consult on backend systems, accounting, and controllership that keeps pace with your needs and won’t overwhelm your team.',
      },
    ],
  },
  whatMakesUsUnique: {
    points: [
      {
        boldPhrase: 'We understand you',
        description:
          'We’ve been where you are, and we understand the landscape. Our team has deep experience in all stages of the startup journey and a track record of realistic projections.',
      },
      {
        boldPhrase: 'We’ll meet you where you are',
        description:
          'When you speak with us, you’ll be talking with a peer, not a suit. We’ll work to understand your business and find the sweet spot between your mission and your business model.',
      },
      {
        boldPhrase: 'You’ll have a sense of control',
        description:
          'We believe in calculated risks, not too conservative, not too aggressive. And we optimize for simplicity and ease of use, so you can spread your wings on your own terms.',
      },
    ],
  },
  allTurtlesInAction: {
    backgroundColor: 'bg-navy',
    backgroundImage: '/images/services/finance_bentoville.png',
    mobileBackgroundImage: '/images/services/finance_bentoville.png',
    title: 'Redefining the art of dinner with Bentoville',
    paragraphs: [
      "Bentoville is meeting a gap that's common in smaller metro areas, improving quality of life through access to world-class cuisine. Taking an experimental approach, Bentoville features live events featuring traveling guest chefs, an ever-evolving takeout menu, sustained partnerships with established brands, and development of a permanent physical space.",
      "Each step of Bentoville's journey presents fresh financial complexities, requiring financial models and processes that can stay up-to-date and evolve quickly. All Turtles has supported Bentoville every step of the way, helping to secure funding from local, national, and Japanese investors, enabling the team to seize opportunities and continually push the envelope in Northwest Arkansas' bustling scene.",
    ],
    testimonialPhoto: '/images/services/finance_lisa.png',
    testimonialPhotoAlt: 'Lisa Smith, Head of Finance, All Turtles',
    testimonialQuote:
      'AT’s finance team scales with you, whether that means setting up the basics, building your first financial model for a fundraise, supporting day-to-day operations, or helping you reach goals like profitability. As the company grows, we’re there to support rapid expansion or help navigate tougher moments, always as a true partner.',
    testimonialPerson: 'Lisa Smith',
    testimonialTitle: 'Head of Finance, All Turtles',
  },
};


export const ServicePage = () => {
  return <ServiceModules content={BRAND_DESIGN_SERVICE_CONTENT} />;
};
